import React from 'react';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import Slider from 'Components/Slider';
import Checkbox from 'Components/Checkbox';
import { Input } from 'Components/Input';
import ApplicationActions from 'Components/ApplicationActions';

export default class PersonPowerCapacity extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...props.boat.powerCapacity };

    this.inputErrors = [];
    this.requiredFieldsList = [];

    this.inputErrors = [];
    this.requiredFieldsList = [];
  }

  componentDidMount() {
    this.getRequiredFieldsList();
  }

  getRequiredFieldsList = () => {
    const { maxSpeedLessThan30, passesTestAtFullPower } = this.state;

    let newState = this.state;

    this.requiredFieldsList = [];
    if (!maxSpeedLessThan30 && !passesTestAtFullPower) {
      this.requiredFieldsList.push('maneuveringSpeed');
    } else {
      delete newState.maneuveringSpeed;
      const index = this.inputErrors.indexOf('maneuveringSpeed');
      if (index !== -1) {
        this.inputErrors.splice(index, 1);
      }
    }
    this.setState(newState);
  };

  toggleValue = type => () => {
    const { markStepAsRedacted } = this.props;

    markStepAsRedacted();
    this.setState(prevState => ({ [type]: !prevState[type] }), this.getRequiredFieldsList);
  };

  handleSpeedInput = targetField => (value, error) => {
    const { markStepAsRedacted } = this.props;

    markStepAsRedacted();
    const index = this.inputErrors.indexOf(targetField);
    if ((error || !value || value < 1) && this.requiredFieldsList.indexOf(targetField) !== -1) {
      if (index === -1) this.inputErrors.push(targetField);
    } else if (index !== -1) {
      this.inputErrors.splice(index, 1);
    }
    this.setState({ [targetField]: value });
  };

  validateStep = () => {
    return new Promise((resolve, reject) => {
      this.requiredFieldsList.forEach(field => {
        const index = this.inputErrors.indexOf(field);
        if ((!this.state[field] || this.state[field] === '') && index === -1) this.inputErrors.push(field);
      });
      if (this.inputErrors.length) {
        this.forceUpdate();
        reject();
      } else {
        resolve();
      }
    });
  };

  handleMoveToNextStep = () => {
    const { boat, updateBoatDetails, goToStep } = this.props;

    this.validateStep().then(() => {
      updateBoatDetails({ powerCapacity: { ...this.state } });
      http.patch(boatAPI.savePowerCapacity(boat.id), this.state).then(() => goToStep('next', true));
    });
  };

  handleMoveToArbitraryStep = stepId => {
    const { boat, updateBoatDetails, goToStep, stepIsChanged } = this.props;

    if (!stepIsChanged) {
      return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
    }

    this.validateStep()
      .then(() => {
        http.patch(boatAPI.savePowerCapacity(boat.id), this.state).then(() => {
          updateBoatDetails({ powerCapacity: { ...this.state } });
          goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
        });
      })
      .catch(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', false);
      });
  };

  render() {
    const { boat, updateBoatDetails, getNavBar, getHeader, stepIsChanged } = this.props;
    const { passesTestAtFullPower, maxSpeedLessThan30, maneuveringSpeed } = this.state;

    return (
      <React.Fragment>
        {getHeader(() => {
          return new Promise(resolve => {
            this.validateStep().then(() => {
              http.patch(boatAPI.savePowerCapacity(boat.id), this.state).then(() => {
                updateBoatDetails({ powerCapacity: { ...this.state } });
                resolve();
              });
            });
          });
        })}
        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}
        <section className='scene_section power-capacity-section _border_top_1'>
          <header>Max Power Capacity</header>
          <Slider
            state={maxSpeedLessThan30}
            mainWrapperClassName='green'
            label='Maximum Speed'
            onLabel='< 30 Mph'
            offLabel='> 30 Mph'
            toggleAction={this.toggleValue('maxSpeedLessThan30')}
          />
          {!maxSpeedLessThan30 && (
            <div className='additional-info-wrapper'>
              <Checkbox
                value={passesTestAtFullPower}
                label='Passes Test At Full Power'
                onChange={this.toggleValue('passesTestAtFullPower')}
              />
              <Input
                isNumeric
                inputClassName='_border_radius_10 _margin_bottom_20 _margin_top_12 _height_40 _width_330'
                label='Maneuvering Speed'
                value={maneuveringSpeed || ''}
                onChange={this.handleSpeedInput('maneuveringSpeed')}
                disabled={passesTestAtFullPower ? 'disabled' : ''}
                error={this.inputErrors.indexOf('maneuveringSpeed') !== -1}
                units='Mph'
              />
            </div>
          )}
        </section>
        <ApplicationActions
          backButtonLabel='Prev. Step'
          saveButtonLabel='Next Step'
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/PowerCapacity.jsx